import React from 'react';
import ExpandMoreIcon from 'components/pure/utils/icon/ExpandMore';
import './DropDownMenuButton.styl';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';

export default class extends React.PureComponent {
  render() {
    // We don't want to specify a color if variant is outlined.
    const color = this.props.variant === 'outlined' ? undefined : 'primary';

    return (
      <Button
        variant={this.props.variant ? this.props.variant : 'contained'}
        fullWidth
        size={this.props.size}
        color={color}
        className={classNames(
          'drop-down-menu-button ev-button',
          this.props.flash && 'flash-button',
          this.props.className
        )}>
        {this.props.children}
        <ExpandMoreIcon />
      </Button>
    );
  }
}
